import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const rudderStack = defineConnector({
  identifier: "rudderStack",
  name: "RudderStack",
  tagLine: "Open-source customer data platform",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api\\.rudderstack\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create a personal access token",
      items: [
        {
          kind: "markdown",
          content:
            "In [RudderStack](https://app.rudderstack.com/), open **Settings › Personal access tokens** and generate a token.",
        },
      ],
    },
    {
      title: "Paste your access token",
      items: [
        {
          kind: "input",
          label: "Personal access token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.rudderstack.com/v2/sources",
  },
});
